/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */
(function ($) {
  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.

  var resizeTimer;
  var itemWidth;

  const env = {
    apiUrl: "https://investors-api.nnnreit.com",
  };

  function headerHeight() {
    var tickerHeight = $(".ticker").outerHeight(),
      navHeight = $(".header").outerHeight(),
      heroText = $("#slider .title").outerHeight(),
      brandText = $("#slider .no-bg").outerHeight();

    $("#slider").attr(
      "style",
      "--offset: " + (tickerHeight + navHeight + heroText + brandText) + "px"
    );
  }

  function tickerLength() {
    itemWidth = $(".ticker li div").outerWidth();

    $(".ticker li div").attr(
      "style",
      "--timing: " + itemWidth + "ms; --width: " + itemWidth + "px"
    );
  }

  var Sage = {
    // All pages
    common: {
      init: function () {
        // JavaScript to be fired on all pages
        tickerLength();

        $("#slider").flexslider({
          animation: "fade",
          // smoothHeight: false,
          controlNav: false,
          directionNav: false,
          // touch: false,
          // slideshowSpeed: 5000
        });

        $(".section-slides").flexslider({
          animation: "fade",
          // smoothHeight: false,
          controlNav: false,
          directionNav: false,
          // touch: false,
          // slideshowSpeed: 5000
        });
        var ww = document.body.clientWidth;

        if (ww > 1024) {
          $("#accordion>h2").prepend("<span></span>");
          $("#accordion>h2")
            .click(function () {
              $(this).toggleClass("on").next().slideToggle();
            })
            .next()
            .hide();
        }

        const hash = window.location.hash.substring(1);

        if (hash) {
          const targetElement = $(`#accordion > #${hash}`);

          if (targetElement.length) {
            targetElement.addClass("on");
            targetElement.next().css("display", "block");
          }
        }

        $(".investor-search form").on("submit", function (e) {
          e.preventDefault();
          const searchType = $('input[name="search-type"]:checked').val();
          const searchQuery = $('input[name="s"]').val();
          const baseUrl = window.location.origin;
          let targetUrl;

          if (searchType === "Documents") {
            targetUrl =
              baseUrl +
              "/investor-relations/sec-filings/?title=" +
              encodeURIComponent(searchQuery) +
              "&results=1";
          } else {
            targetUrl = baseUrl + "/?s=" + encodeURIComponent(searchQuery);
          }

          window.location.href = targetUrl;
        });

        $(".investor-search form").on("submit", function (e) {
          e.preventDefault();
          const searchType = $('input[name="search-type"]:checked').val();
          const searchQuery = $('input[name="s"]').val();
          const baseUrl = window.location.origin;
          let targetUrl;

          if (searchType === "Documents") {
            targetUrl =
              baseUrl +
              "/investor-relations/sec-filings/?title=" +
              encodeURIComponent(searchQuery) +
              "&results=1";
          } else {
            targetUrl = baseUrl + "/?s=" + encodeURIComponent(searchQuery);
          }

          window.location.href = targetUrl;
        });

        // });
      },
      finalize: function () {
        // JavaScript to be fired on all pages, after page specific JS is fired

        $(window).on("resize", function (e) {
          clearTimeout(resizeTimer);
          resizeTimer = setTimeout(function () {
            tickerLength();
          }, 500);
        });

        $(window).load(function () {
          tickerLength();

          // var stickybits;
          // var stickybits;
          // var resizeTimer;
          // var itemWidth = $('.ticker li div').outerWidth();
          // tickerLength();

          // function tickerLength() {

          //   itemWidth = $('.ticker li div').outerWidth();

          //   $('.ticker li div').attr('style', '--timing: ' + itemWidth + 'ms; --width: ' + itemWidth + 'px');

          // }

          $(".ticker").stickybits();

          var objFitImgs = $(
            ".main-img, .imageSection img, .green-bar, .details-grid img, .flexslider .slides img, .testimonials-list .img"
          );
          window.objectFitImages(objFitImgs);
        });
      },
    }, // Home page
    home: {
      init: function () {
        // JavaScript to be fired on the home page
        headerHeight();
      },
      finalize: function () {
        // JavaScript to be fired on the home page, after the init JS

        $(window).on("resize", function (e) {
          clearTimeout(resizeTimer);
          resizeTimer = setTimeout(function () {
            tickerLength();
            headerHeight();
          }, 500);
        });

        $(window).load(function () {
          headerHeight();
        });
      },
    }, // About us page, note the change from about-us to about_us.
    about_us: {
      init: function () {
        // JavaScript to be fired on the about us page
      },
    },
    corporate_sustainability: {
      init: function () {
        // Select the floating element
        const floatingElement = document.querySelector(".cr-floating-nav");


        // Intersection Observer callback
        const observerCallback = (entries, observer) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              // Check if the section has 'dark-mode' class
              if (entry.target.classList.contains("dark-mode")) {
                console.log("dark");
                document.body.classList.add("dark-mode");
                document.body.classList.remove("light-mode");
              } else if (entry.target.classList.contains("light-mode")) {
                console.log("light");
                document.body.classList.add("light-mode");
                document.body.classList.remove("dark-mode");
              }
            }
          });
        };

        // Options for the observer
        const observerOptions = {
          root: null,
          threshold: 0.25,
        };

        const observer = new IntersectionObserver(
          observerCallback,
          observerOptions
        );

        const sectionColors = document.querySelectorAll("section");
        sectionColors.forEach((section) => {
          observer.observe(section);
        });


        
        const sections = document.querySelectorAll(".cr-section");
        const navLinks = document.querySelectorAll(".cr-floating-nav a");

        // Function to get the active section
        function getActiveSection() {
          let index = sections.length;

          while (
            --index &&
            window.scrollY + window.innerHeight / 3 < sections[index].offsetTop
          ) {}
          return index;
        }

        function updateNav() {
          let activeIndex = getActiveSection();

          navLinks.forEach((link, index) => {
            if (index === activeIndex) {
              link.classList.add("active");
            } else {
              link.classList.remove("active");
            }
          });
        }

        window.addEventListener("scroll", updateNav);

        navLinks.forEach((link) => {
          link.addEventListener("click", function (event) {
            event.preventDefault();
            const targetSection = document.querySelector(
              this.getAttribute("href")
            );
            if (targetSection) {
              window.scrollTo({
                top: targetSection.offsetTop,
                behavior: "smooth",
              });
            }
          });
        });

        updateNav();

        gsap.registerPlugin(ScrollTrigger);

        let mm = gsap.matchMedia();

        mm.add("(min-width: 2px)", () => {
          gsap.to(".cr-carbon-leaf.left", {
            xPercent: -95,
            scrollTrigger: {
              trigger: ".cr-carbon",
              start: "top bottom",
              end: "top 60%",
              scrub: 2,
            },
          });

          gsap.to(".cr-carbon-leaf.right", {
            xPercent: 95,
            scrollTrigger: {
              trigger: ".cr-carbon",
              start: "top bottom",
              end: "top 60%",
              scrub: 2,
            },
          });
        });

        mm.add("(min-width: 1225px)", () => {
          gsap.to(".cr-carbon-leaf.left", {
            xPercent: -85,
            scrollTrigger: {
              trigger: ".cr-carbon",
              start: "top bottom",
              end: "top 60%",
              scrub: 2,
            },
          });

          gsap.to(".cr-carbon-leaf.right", {
            xPercent: 90,
            scrollTrigger: {
              trigger: ".cr-carbon",
              start: "top bottom",
              end: "top 60%",
              scrub: 2,
            },
          });
        });

        gsap.to(".cr-social-bg-img", {
          scale: 1.6,
          ease: "none",
          scrollTrigger: {
            trigger: ".cr-social",
            start: "top bottom",
            end: "bottom top",
            scrub: 1,
          },
        });
      },
    },
    buy_a_property_from_us: {
      init: function () {
        $(document).on("gform_confirmation_loaded", function (event, formId) {
          if (formId === 3) {
            const pdfUrl = document.querySelector(".property-modal-btn").dataset
              .pdf;
            if (pdfUrl) {
              // Create a wrapper div
              const buttonWrapper = $(
                '<div class="download-brochure-wrapper"></div>'
              );

              const viewButton = $('<a class="download-brochure"></a>')
                .text("View")
                .attr("href", pdfUrl)
                .attr("target", "_blank");

              const downloadButton = $('<a class="download-brochure"></a>')
                .attr("href", pdfUrl)
                .attr("download", "")
                .html(
                  'Download <svg width="22" height="21" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M17.875 15.75v2.625H4.125V15.75H2.75v2.625c0 .348.145.682.403.928s.607.384.972.384h13.75c.365 0 .714-.138.972-.384s.403-.58.403-.928V15.75h-1.375zM17.875 9.188l-.97-.926-5.218 4.975V1.312h-1.374v11.925L5.093 8.262l-.969.925L11 15.75l6.875-6.563z" fill="currentColor"></path></svg>'
                );

              buttonWrapper.append(viewButton);
              buttonWrapper.append(downloadButton);

              $(".gform_confirmation_message").append(buttonWrapper);
            }
          }
        });
        propertyAlpine();
      },
      finalize: function () {},
    },

    logo_kit: {
      init: function () {
        $(".logo-accordion").click(function () {
          $(this).next(".logo-accordion-content").slideToggle();
          $(this).toggleClass("active");
        });
        // JavaScript to be fired on the about us page
      },
    },
    category: {
      // finalize: function () {
      //   var DateRangePicker = window.DateRangePicker && window.DateRangePicker.DateRangePicker ? window.DateRangePicker.DateRangePicker : false;
      //   if (DateRangePicker) {
      //     const root = document.querySelector('.date-inputs');
      //     const txtStart = root.querySelector('.date-inputs-start');
      //     const txtEnd = root.querySelector('.date-inputs-end');
      //     const txtBtn = root.querySelector('.date-input-btn');
      //     const txtOutStart = root.querySelector('.date-output-start');
      //     const txtOutEnd = root.querySelector('.date-output-end');
      //     const container = root.querySelector('.date-inputs-picker');
      //     const today = new Date();
      //     let cur = { start: false, end: false };
      //     DateRangePicker(container, {
      //       startOpts: {
      //         format: formatToQueryArg,
      //         parse: parseQueryArg,
      //         min: '1/1/2010',
      //         max: today.toLocaleDateString()
      //       },
      //       endOpts: {
      //         format: formatToQueryArg,
      //         parse: parseQueryArg,
      //         min: '1/1/2010',
      //         max: today.toLocaleDateString()
      //       },
      //     })
      //       .on('statechange', function (_, rp) {
      // Update the inputs when the state changes
      // var range = rp.state;
      // var start = range.start ? formatToQueryArg(range.start) : '';
      // cur.start = start;
      // txtStart.value = start;
      // txtOutStart.innerHTML = start;
      // var end = range.end ? formatToQueryArg(range.end) : '';
      // cur.end = end;
      // txtEnd.value = end;
      // txtOutEnd.innerHTML = end;
      //       });
      // When the inputs gain focus, show the date range picker
      // txtBtn.addEventListener('click', function () {
      //   txtStart.focus();
      // })
      // txtOutStart.addEventListener('click', function(e) {
      //   e.preventDefault();
      //   txtStart.focus();
      // });
      // txtOutEnd.addEventListener('click', function (e) {
      //   e.preventDefault();
      //   txtEnd.focus()
      // });
      // txtStart.addEventListener('focus', showPicker);
      // txtEnd.addEventListener('focus', showPicker);
      // function showPicker() {
      //   clearTimeout(refreshTimeout);
      //   container.classList.add('date-inputs-picker-visible');
      // }
      // let previousTimeout;
      // let refreshTimeout;
      // root.addEventListener('focusout', function hidePicker() {
      //   clearTimeout(previousTimeout);
      //   previousTimeout = setTimeout(function() {
      //     if (!root.contains(document.activeElement)) {
      //       container.classList.remove('date-inputs-picker-visible');
      //     }
      //     if (cur.start && cur.end) {
      //       refreshTimeout = window.setTimeout(function () {
      //         if (cur.start && cur.end) {
      //           root.submit();
      //         }
      //       }, 750)
      //     }
      //   }, 10);
      // });
      //     function formatToQueryArg (d) {
      //       return [d.getUTCFullYear(), d.getUTCMonth() + 1, d.getUTCDate()].join('-')
      //     };
      //     function parseQueryArg(str) {
      //       var date = new Date(str);
      //       return isNaN(date) ? new Date() : date;
      //     }
      //   }
      // }
    },
    stock_quote: {
      finalize: function () {
        stockQuote(env);
        stockChart(env);
        // historicPriceLookup(env);
      },
    },
  };
  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function (func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = funcname === undefined ? "init" : funcname;
      fire = func !== "";
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === "function";
      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function () {
      // Fire common init JS
      UTIL.fire("common");
      // Fire page-specific init JS, and then finalize JS
      $.each(
        document.body.className.replace(/-/g, "_").split(/\s+/),
        function (i, classnm) {
          UTIL.fire(classnm);
          UTIL.fire(classnm, "finalize");
        }
      );
      // Fire common finalize JS
      UTIL.fire("common", "finalize");
    },
  };
  // Load Events
  $(document).ready(UTIL.loadEvents);
})(jQuery); // Fully reference jQuery after this point.
